import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand-section">
            <div className="footer-logo">
              <img src="/logos/12thplus-logo-white.png" alt="12thPlus.com" className="logo-img" />
            </div>
            <p className="brand-tagline">Because the right career decision begins with the right information.</p>
            <p className="brand-motto">
              <span className="motto-word orange">Clarity.</span>
              <span className="motto-word teal">Confidence.</span>
              <span className="motto-word">Smarter Decisions.</span>
            </p>
          </div>

          {/* Quick Links Column */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/students">Students & Parents</Link></li>
              <li><Link to="/institutions">Institutions</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Streams Column */}
          <div className="footer-column">
            <h4>Streams Covered</h4>
            <ul>
              <li><Link to="/streams/engineering">Engineering & Technology</Link></li>
              <li><Link to="/streams/medical">Medical & Allied Health</Link></li>
              <li><Link to="/streams/commerce">Commerce & Management</Link></li>
              <li><Link to="/streams/law">Law</Link></li>
              <li><Link to="/streams/arts">Arts & Humanities</Link></li>
              <li><Link to="/streams/architecture">Architecture & Design</Link></li>
            </ul>
          </div>

          {/* Contact Column */}
          <div className="footer-column">
            <h4>Contact Us</h4>
            <ul className="contact-list">
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <a href="mailto:info@12thplus.com">info@12thplus.com</a>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>+91 98765 43210</span>
              </li>
              <li>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ alignSelf: 'flex-start', marginTop: '3px' }}>
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>GooCampus Edu Solutions Pvt Ltd<br />#138/6, Ground Floor, 10th Main Road,<br />6th A Cross, Sadashiv Nagar, RMV Extension,<br />Behind SBI Bank, Bangalore,<br />Karnataka - 560080, India.</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">&copy; 2025 12thPlus.com. All rights reserved.</p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
